export default __webpack_public_path__ + "static/auvelity-logo-c4e0ab6fbf6d4a2f010836277ea1bb1a.svg";